import { render } from "./ResetPasswordView.vue?vue&type=template&id=0ae090ad&scoped=true&ts=true"
import script from "./ResetPasswordView.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordView.vue?vue&type=script&lang=ts"

import "./ResetPasswordView.vue?vue&type=style&index=0&id=0ae090ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ae090ad"]])

export default __exports__